import { getApiData } from '.';
import { Prebooking } from '../types/store';

export const getInitPrebookingData = () => {
  const output: Prebooking = {
    selectedVehicle: null,
    selectedProject: null,
    selectedDate: null,
    projects: getApiData({}),
    recentProjects: getApiData([]),
    nearbyProjects: getApiData([]),
    allProjects: getApiData([]),
    bookings: getApiData([]),
  };

  return output;
};
